import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateNewsDes } from "../../actions/formActions";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';
import  Web3 from 'web3';
import 'react-toastify/dist/ReactToastify.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))


let toasterOption = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false, 
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
}
class NewsDesUpdateModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.record._id,
            Title: this.props.record.Title,
            Heading:this.props.record.Heading,
            Description: this.props.record.Description,
            NewsLink : this.props.record.NewsLink,
            VimeoLink : this.props.record.VimeoLink,
            file:{},
            errors: {},
           };
    }
    componentDidMount(props){
        console.log("data>>>>>>> :",this.props)
        
    }
    
   
    componentWillReceiveProps(nextProps) {
         //console.log("next Props>>>>",nextProps)
        if (nextProps.record) {
            this.setState({
                id: nextProps.record._id,
                Title: nextProps.record.Title,
               Heading:nextProps.record.Heading,
               Description: nextProps.record.Description,
               NewsLink :nextProps.record.NewsLink,
               VimeoLink : nextProps.record.VimeoLink,
                file: nextProps.record.file,
            })
           // console.log("data 2 : ",nextProps.record.quoteTokenSymbol)
        }
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
        if (nextProps.auth !== undefined
            && nextProps.auth.form !== undefined
            && nextProps.auth.form.data !== undefined
            && nextProps.auth.form.data.message !== undefined
            && nextProps.auth.form.data.success) {
           
            toast(nextProps.auth.form.data.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
            $('#update-newsdes-modal').modal('hide');
        
    }

    onChange = e => {
       
        
        if (e.target.id === 'Title') {
            this.setState({ Title: e.target.value });
        }
       if (e.target.id === 'Heading') {
          this.setState({ Heading: e.target.value });
        }
        if (e.target.id === 'Description') {
            this.setState({ Description: e.target.value });
        }
        if (e.target.id === 'NewsLink') {
            this.setState({ NewsLink: e.target.value });
        }
        if (e.target.id === 'VimeoLink') {
            this.setState({ VimeoLink: e.target.value });
        }
        

        

    };


     handleChange = (value) => {
        this.setState({ Description:value });       
       }
    onFileChange = event => {
        var name = event.target.value;
           // Update the state
           this.setState({ file: event.target.files[0]});
           this.setState({ imagepath: name});
          
         };


    // onFileChange = async(event) => {
    //     var name = event.target.value;
    //     this.setState({ file: event.target.files[0]});
    //     this.setState({ imagepath: name});
    //        var width;
    //        var height;
    //        var img = new Image()
    //        img.src = window.URL.createObjectURL(event.target.files[0])
    //        img.onload = () => {
    //         width = img.width;
    //         height = img.height;
      
           
        
    //        if ( Number(width) != Number(1600) && Number(height) != Number(675)){
    //         toast.error(`Image Height and width should be ${675} pixel and ${1600} pixel`,{
    //             style: {
    //             minWidth: '300px',
    //             minHeight: '55px'
    //             }
    //         }) 

    //         this.setState({ file: ""});
    //               this.setState({ imagepath: ""});
             
    //       }
          
    //         sleep(2000) 
           
    
    //        }
    //      };
   
    onFormUpdate = e => {
        e.preventDefault();
        const updateForm = {
            _id: this.state.id,
            Title: this.state.Title,
            Heading:this.state.Heading,
            Description:this.state.Description,
            NewsLink : this.state.NewsLink,
            VimeoLink: this.state.VimeoLink,
            file: this.state.file
 
        };
        this.props.updateNewsDes(updateForm);
    };

    render() {
        const { errors } = this.state;
        return (
            <div>
            <div className="modal fade" id="update-newsdes-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Update News Description</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <form noValidate id="update-form">
                                <input
                                    onChange={this.onChange}
                                    value={this.state.id}
                                    id="form-update-id"
                                    type="text"
                                    required
                                    className="d-none"/>
                              
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="tokenAddresses">Title</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            onChange={this.onChange}
                                            value={this.state.Title}
                                            error={errors.Title}
                                            id="Title"
                                            type="text"
                                            required
                                            className={classnames("form-control", {
                                                invalid: errors.Title
                                            })}
                                        />
                                        <span className="text-danger">{errors.Title}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="quoteTokenAdresses">Heading</label>
                                    </div>
                                    <div className="col-md-9">
                                        <textarea
                                            onChange={this.onChange}
                                            value={this.state.Heading}
                                            error={errors.Heading}
                                            id="Heading"
                                            type="text"
                                            className={classnames("form-control", {
                                                invalid: errors.Heading
                                            })}
                                        />
                                        <span className="text-danger">{errors.Heading}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="depositFee">Description</label>
                                    </div>
                                    <div className="col-md-9">
                                    <ReactQuill                                               
                                    
                                           onChange={this.handleChange}
                                            value={this.state.Description}
                                            error={errors.Description}
                                            id="Description"
                                            theme="snow" 
                                               type="text" 
                                            // className={classnames("form-control", {
                                            //     invalid: errors.Description
                                            // })}
                                        />
                                        <span className="text-danger">{errors.Description}</span>
                                    </div>
                                   
                                   
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="depositFee">Youtube Link</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                          
                                           onChange={this.onChange}
                                            value={this.state.NewsLink}
                                            error={errors.NewsLink}
                                            id="NewsLink"
                                           
                                            className={classnames("form-control", {
                                                invalid: errors.NewsLink
                                            })}
                                        ></input>
                                        <span className="text-danger">{errors.NewsLink}</span>
                                    </div>
                                   
                                   
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="depositFee">Vimeo Link</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                          
                                           onChange={this.onChange}
                                            value={this.state.VimeoLink}
                                            error={errors.VimeoLink}
                                            id="VimeoLink"
                                           
                                            className={classnames("form-control", {
                                                invalid: errors.VimeoLink
                                            })}
                                        ></input>
                                        <span className="text-danger">{errors.VimeoLink}</span>
                                    </div>
                                   
                                   
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="logoURI">Update Image</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            autoComplete={''}
                                            onChange={this.onFileChange}
                                            value={this.state.imagepath}
                                            error={errors.logoURI}
                                            id="logoURI"
                                            type="file"
                                            className={classnames("form-control", {
                                                invalid: errors.logoURI
                                            })}
                                        />
                                        <span className="text-danger">{errors.logoURI}</span>
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <a
                                form="update-form"
                               
                                className="btn btn-primary" onClick={this.onFormUpdate}>
                                Update
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}

NewsDesUpdateModal.propTypes = {
    updateForm: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { updateNewsDes }
)(withRouter(NewsDesUpdateModal));
